/**
 * SYM-6197. Whether an ad is worth keeping after the video was abandoned.
 *
 * Reaching the video wizard from an empty ad means pressing the plus on a
 * placement, which makes a blank ad, and then asking for a video inside it. If
 * the campaign has too few pictures the wizard refuses, and answering "Not now"
 * used to leave that blank ad sitting in the list -- an ad the customer never
 * asked for, holding nothing, which they now have to notice and delete.
 *
 * So it is cleared away, but only when it is genuinely a leftover: an ad that
 * carries nothing and has never been saved. An ad with a picture on it, or one
 * that already exists on the server, is the customer's and is left alone even
 * if they walked away from the video.
 */

interface MaybeEmptyVariant {
  /** Set once the ad exists on the server. */
  id?: number;
  /** The picture or video on the ad, if any. */
  path?: unknown;
  /** A drawing saved on the ad. */
  svg?: string | null;
  data_url?: string;
}

export function isEmptyUnsavedVariant(
  variant: MaybeEmptyVariant | null | undefined
): boolean {
  if (!variant) return false;
  if (typeof variant.id === 'number') return false;

  const hasPicture = !!variant.path;
  const hasDrawing = !!variant.svg || !!variant.data_url;

  return !hasPicture && !hasDrawing;
}
